/// home marquee section js

jQuery(document).ready(function ($) {
  $(".slick.marquee").slick({
    speed: 3000,
    autoplay: true,
    autoplaySpeed: 0,
    centerMode: true,
    cssEase: "linear",
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    infinite: true,
    initialSlide: 1,
    arrows: false,
    buttons: false,
  });
});

/// About-us marquee section js

jQuery(document).ready(function ($) {
  $(".slick.slider.marquee").slick({
    speed: 3000,
    autoplay: true,
    autoplaySpeed: 0,
    centerMode: true,
    cssEase: "linear",
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    infinite: true,
    initialSlide: 1,
    arrows: false,
    buttons: false,
  });
  $('.marque-slider-pro').slick({
    speed: 7000,
    autoplay: true,
    autoplaySpeed: 0,
    centerMode: true,
    cssEase: 'linear',
    slidesToShow: 1,
    draggable:false,
    focusOnSelect:false,
    pauseOnFocus:false,
    pauseOnHover:false,
    slidesToScroll: 1,
    variableWidth: true,
    infinite: true,
    initialSlide: 1,
    arrows: false,
    buttons: false
  });
});

// submit button js

$(document).ready(function () {

  $('body').on('click','.header-search-opener',function(){
    $(this).hide();
    $(this).closest('.header__icons').find('.predictive-search-wp').removeAttr('hidden');
  });
  
  $("button").click(function () {
    $(".footer__submit").hide();
  });
  $("button").click(function () {
    $(".p").show("slow");
  });
});

//  header sticky js

$(document).ready(function () {
  $(window).scroll(function () {
    if ($(this).scrollTop() > 1) {
      $(".header-wrapper").addClass("sticky");
    } else {
      $(".header-wrapper").removeClass("sticky");
    }
  });
});

///  moblie screen reviews slider

$(".profile-logos").slick({
  dots: true,
  arrows: true,
  prevArrow: ".arrow_prev",
  nextArrow: ".arrow_next",
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});

// video js

document.getElementById("video").play();

document.getElementById("in-video").play();

setTimeout(function () {
  $(".shopify-payment-button__button").text("SHOP IT NOW");
}, 1000);
